module.exports = coreApis.componentApis.feeds.api;